

export default{
	//日期格式化，e为空时，获取当前日期
	dateFormat: (e) => {
		let now = null
		if(typeof e === 'undefined') {
			now = new Date();
		}else {
			now = new Date(e);
		}
		let yy = now.getFullYear();
		var mm = (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
		var dd = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
		return yy + "-" + mm + "-" + dd;
	},
	//时间格式化，e为空时，获取当前时间
	timeFormat: (e) => {
		let now = null
		if(typeof e === 'undefined') {
			now = new Date();
		}else {
			now = new Date(e);
		}
		let yy = now.getFullYear();
		var mm = (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
		var dd = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
		let hh = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();;
		let mf = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
		let ss = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
		return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
	},
	
}